import { render, staticRenderFns } from "./intio-word.vue?vue&type=template&id=2e26cb24&scoped=true&"
import script from "./intio-word.vue?vue&type=script&lang=ts&"
export * from "./intio-word.vue?vue&type=script&lang=ts&"
import style0 from "./intio-word.vue?vue&type=style&index=0&id=2e26cb24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e26cb24",
  null
  
)

export default component.exports